import { useState, useEffect } from 'react';
import { axiosInstance } from '../utils/axiosConfig';

export interface Consents {
  data_storage: boolean;
  ai_review: boolean;
  email_access: boolean;
  web_crawl: boolean;
}

export const useConsents = () => {
  const [consents, setConsents] = useState<Consents>({
    data_storage: false,
    ai_review: false,
    email_access: false,
    web_crawl: false,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchConsents = async () => {
    setLoading(true);
    setError(null);
    try {
      // Use the shared axiosInstance so the request honours REACT_APP_API_URL
      // (relative `/api` in dev → goes through the CRA proxy → works behind
      // VS Code port forwarding) and carries the bearer token + CSRF header.
      const response = await axiosInstance.get('/consents/all');
      setConsents(response.data);
    } catch (err) {
      console.error('Fetch consents error:', err);
      setError('Failed to load consents');
    } finally {
      setLoading(false);
    }
  };

  const updateConsent = async (type: string, granted: boolean) => {
    // Optimistically update so the UI flips immediately; revert on failure.
    const previous = consents[type as keyof Consents];
    setConsents(prev => ({ ...prev, [type]: granted }));
    try {
      const endpoint = type.replace(/_/g, '-');
      await axiosInstance.post(`/consents/${endpoint}`, { agreed: granted });
      return true;
    } catch (err) {
      console.error('Update consent error:', err);
      setError('Failed to update consent');
      setConsents(prev => ({ ...prev, [type]: previous }));
      return false;
    }
  };

  useEffect(() => {
    fetchConsents();
  }, []);

  return { consents, loading, error, updateConsent, refetch: fetchConsents };
};
